// Saved bookmarks don't record which database they came from, so EBSCO and
// ProQuest items are recognised by their result URL host.
const DATABASE_HOSTS = ["search.ebscohost.com", "proquest.com"];

export const isDatabaseSourceUrl = (url) => {
  try {
    const hostname = new URL(url).hostname.toLowerCase();
    return DATABASE_HOSTS.some(
      (host) => hostname === host || hostname.endsWith(`.${host}`)
    );
  } catch {
    return false;
  }
};

// EBSCO record id (database id + accession number). Search results carry it on
// summaryInfoData; saved bookmarks only have the result URL (…&db=X&AN=Y…).
export const getEbscoRecordId = (summaryInfoData = {}) => {
  if (summaryInfoData.dbId && summaryInfoData.an) {
    return { dbId: summaryInfoData.dbId, an: summaryInfoData.an };
  }
  try {
    let url = new URL(summaryInfoData.url);
    const target = url.searchParams.get("TargetResource");
    if (url.hostname.toLowerCase().endsWith("ebscohost.com") && target) {
      url = new URL(target);
    }
    if (url.hostname.toLowerCase() !== "search.ebscohost.com") return null;
    const params = {};
    url.searchParams.forEach((value, key) => {
      params[key.toLowerCase()] = value;
    });
    return params.db && params.an ? { dbId: params.db, an: params.an } : null;
  } catch {
    return null;
  }
};

export const EBSCO_CITATION_STYLES = {
  apa: "apa",
  "modern-language-association": "mla",
  "chicago-author-date": "chicago",
  "turabian-fullnote-bibliography": "turabian",
};
